import ImageTool from '@editorjs/image';

const customImageUploader = async (file, folderName, docId) => {
    const formData = new FormData();
    formData.append('files', file);
    formData.append('folderName', folderName);
    formData.append('docId', docId);

    const response = await fetch('api/Http/ImageUpload', {
        method: 'POST',
        body: formData
    });
    return await response.json();
};

const customImageUrlUploader = async (url, folderName, docId) => {
    const formData = new FormData();
    formData.append('url', url);
    formData.append('folderName', folderName);
    formData.append('docId', docId);

    const response = await fetch('api/Http/ImageUpload', {
        method: 'POST',
        body: formData
    });
    return await response.json();
};

const convertToBase64 = async (file) => {
    const url = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
    return {
        success : 1,
        file : {
            url: url
        }
    };
}

const editorTools = (folderName, docId) => {
    return{
        image: {
            class: ImageTool,
            // shortcut: "CMD+ALT+I",
            config: {
                uploader: {
                    uploadByFile: (file) => !folderName ? convertToBase64(file) : customImageUploader(file, folderName, docId),
                    uploadByUrl: (url) => customImageUrlUploader(url, folderName, docId)
                },
                path: !folderName ? '' : `/doc/${folderName}/${docId}/`
            },
            toolbox: {
                title: '이미지'
            }
        }
    }
};

export const updateLinkEvents = (viewMode) => {
    const handleLinkClick = (event) => {
        event.preventDefault();
        window.open(event.currentTarget.dataset.link, "_blank");
    }
    
    document.querySelectorAll("span[data-link]").forEach((linkNode) => {
        linkNode.removeEventListener("click", handleLinkClick);
        if (viewMode) {
            linkNode.addEventListener("click", handleLinkClick);
        }
    });
}

export const convertDataType = (data, folderName, docId) => {
    if (data && data.blocks && Array.isArray(data.blocks)) {
        data.blocks = data.blocks.flatMap(block => {
            // 사용하지 않는 type이 존재할 경우, 새로운 type으로 변경
            if (block.type === 'header') {
                block.type = 'h1';
            } 
            if (block.type === 'h4') {
                block.type = 'paragraph';
            } 
            if (block.type === 'list') {
                block.type = 'ul';
            }
            if (block.type === 'warning') {
                block.type = 'notice';
            } 
            if(block.type === "paragraph") {
                if (block.tunes && block.tunes.indentTune) {
                    if(block.tunes.indentTune.indentLevel > 0) {
                        block.data.depth = block.tunes.indentTune.indentLevel;
                    }
                }
                if(!block.data.depth && block.data.level) {
                    block.data.depth = block.data.level;
                }
                block.data.text = block.data.text.replaceAll('\n', '<br>');
            }
            if(block.type === "ul" || block.type === "ol") {
                if(block.data.items) {
                    return convertToNewFormat(block);
                } else {
                    if(block.type === "ul") block.type = "unordered";
                    else block.type = "ordered";
                }
            }
            if(block.type === "ulist" || block.type === "olist") {
                if(block.data.items) {
                    return convertToNewFormat(block);
                } else {
                    if(block.type === "ulist") block.type = "unordered";
                    else block.type = "ordered";
                }
            }
            if(block.type === "unordered" || block.type === "ordered") {
                block.data.text = block.data.text?.replaceAll('\n', '<br>');
                if(!block.data.depth && block.data.level) {
                    block.data.depth = block.data.level;
                }
            }
            if(block.type === "image") {
                if(!block.data.file.url.includes("data:image"))
                    block.data.file.url = block.data.file.url.replaceAll('\\','/').split("/").pop();
            }
            if(block.type === "notice") {
                block.data.message = block.data.message.replaceAll('\n', '<br>');
            }
            if(block.type === "table") {
                block.data.content = block.data.content.map(row => row = row.map(item => item.replaceAll('\n', '<br>')));
            }
            if(block.tunes?.indentTune) {
                delete block.tunes.indentTune;
            }
            return [block];
        });
    }
    return data;
};

const convertToNewFormat = (block, indent = 0) => {
    let result = [];
    
    const traverseItems = (type, items, indentLevel) => {
        if(type === "ulist") type = "ul";
        let number = 1;
        
        items.forEach((item) => {
            let newItem = {
            type: type === "ul" ? "unordered" : "ordered",
            data: {
                text: item.content.replaceAll('\n', '<br>'),
                depth: indentLevel,
                number: number,
                indent: type === "ul" ? indentLevel % 2 : indentLevel,
                style: type === "ul" ? "unordered" : "ordered"
            }
            };
    
            result.push(newItem);
    
            if (item.items && item.items.length > 0) {
            traverseItems(type, item.items, indentLevel + 1);
            }
            
            number++;
        });
    }
    
    traverseItems(block.type, block.data.items, indent);
    return result;
};

export default editorTools;